import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { IDropdownSettings } from 'ng-multiselect-dropdown/multiselect.model';
import { ApiService } from '../../services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-modal-adicionar-alerta',
  templateUrl: './modal-adicionar-alerta.component.html',
  styleUrls: ['./modal-adicionar-alerta.component.scss'],
})
export class ModalAdicionarAlertaComponent implements OnInit {

  @Input() corPrimaria: string;
  @Input() title: string;
  @Input() text: any;
  @Input() confirm: any;
  @Input() edicao: any = false;
  @Input() remover: any = false;
  @Output() fecharModal = new EventEmitter();

  constructor(private toast: ToastrService,
    private api: ApiService,
    private loading: NgxSpinnerService,
    private storage: StorageService) {
    }

  ngOnInit() {
  }


  fechar(bol) {
    this.fecharModal.emit();
  }

  adicionar(bol) {
    this.fecharModal.emit(bol);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-adicionar-alerta/modal-adicionar-alerta.component.ts